(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CommunicationCampaignCancelController', CommunicationCampaignCancelController);

    CommunicationCampaignCancelController.$inject = ['$uibModalInstance', 'entity', 'CommunicationCampaign'];

    function CommunicationCampaignCancelController($uibModalInstance, entity, CommunicationCampaign) {
        var vm = this;
        vm.communicationCampaign = entity;
        vm.clear = clear;
        vm.confirmCancel = confirmCancel;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmCancel(id) {
            CommunicationCampaign.cancel({ id: id }, function() {
                $uibModalInstance.close(true);
            });
        }
    }
})();
